import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent branding badge - target the #emergent-badge anchor element
const removeEmergentBadge = () => {
  const removeElements = () => {
    // Target the badge by its ID
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.style.display = 'none';
      badge.style.visibility = 'hidden';
      badge.style.opacity = '0';
      badge.remove();
    }
    
    // Also remove any elements with emergentagent links
    document.querySelectorAll('a[href*="emergentagent"]').forEach(el => {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.remove();
    });
    
    // Remove any body children containing "Emergent" text that aren't #root
    document.querySelectorAll('body > *:not(#root):not(script):not(noscript):not(iframe)').forEach(el => {
      if (el.textContent && el.textContent.includes('Emergent')) {
        el.style.display = 'none';
        el.remove();
      }
    });
  };

  // Run immediately
  removeElements();

  // Run periodically to catch late-injected badges
  const intervalId = setInterval(removeElements, 100);
  
  // Stop after 10 seconds to avoid infinite running
  setTimeout(() => clearInterval(intervalId), 10000);

  // Also use MutationObserver for new elements
  const observer = new MutationObserver(removeElements);
  observer.observe(document.body, { childList: true, subtree: false });
};

// Run after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeEmergentBadge);
} else {
  removeEmergentBadge();
}

// Also run after window load
window.addEventListener('load', removeEmergentBadge);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
